// The order status pill — one dot, one label, shared by the list and the header
// so a status never changes colour between two screens.
import type { OrderStatusValue } from '@my/tms-api';
import {
  ORDER_STATUS_BADGE,
  ORDER_STATUS_DOT,
  ORDER_STATUS_LABEL,
} from '../lib/orderStatus';

/** Dot + label, ring-bordered. `size` follows the surface it sits on. */
export function OrderStatusPill({
  status,
  size = 'sm',
}: {
  status: OrderStatusValue;
  /** `sm` for a table row, `md` for the order header. */
  size?: 'sm' | 'md';
}) {
  return (
    <span
      className={
        `inline-flex items-center gap-1 rounded-full font-medium ring-1 ring-inset ${ORDER_STATUS_BADGE[status]} ` +
        (size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-[10px]')
      }
    >
      <span
        className={`${size === 'md' ? 'h-2 w-2' : 'h-1.5 w-1.5'} rounded-full ${ORDER_STATUS_DOT[status]}`}
        aria-hidden="true"
      />
      {ORDER_STATUS_LABEL[status]}
    </span>
  );
}
